import { Box, Flex } from '@/ui';
import { BAR } from './constants';

export const ListThumbnail = () => (
  <Flex direction="column" gap="5px" pt={1} w="full">
    {[82, 66, 74, 60].map((w, i) => (
      <Box bg={BAR} borderRadius="2px" h="7px" key={i} w={`${w}%`} />
    ))}
  </Flex>
);
